export default __webpack_public_path__ + "static/B0267-1a998033250a6834d0dff3a2ca061736.png";